<template>
    <div>
        <div class="modal fade" id="mdcentralntificacao">
            <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable" >
                <div id="incluir" class="modal-content">
                    <div class="modal-header" style="padding-right: 0px;">
                        <div class="row" style="width: 100%;">
                            <div class="col-8 col-sm-8 col-md-8 col-lg-8 col-xl-8" style="min-height: 36px;">
                                <h4 v-if="parseInt(opnotif) === 0 && titulonotif === ''" class="modal-title">Central de notificação</h4>
                                <h4 v-else class="modal-title">{{ titulonotif }}</h4>
                            </div>
                            <button type="button" class="close" data-dismiss="modal" >&times;</button>
                        </div>
                    </div>
                    <div class="modal-body">
                        <div class="row" style="margin-bottom: 10px;">
                            <div class="col-md-9">
                                <div class="row">
                                    <div class="col-md-12">
                                        <label for="edtitulonotif">Título:</label>
                                        <input type="text" v-model="titulonotif" class="form-control form-control-sm" id="edtitulonotif" v-bind:disabled="parseInt(opnotif) === 2" data-bv-group=".group" maxlength="100">
                                    </div>
                                    <div class="col-sm-12 col-md-4 col-lg-4">
                                        <label for="eddtnotif">Data:</label>
                                        <div class="input-group">
                                            <date-picker id="eddtnotif" v-model="dtnotif" :config="options" 
                                                class="form-control form-control-sm" >
                                            </date-picker>
                                            <div class="input-group-append">
                                                <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                                            </div>                                            
                                        </div>
                                    </div>  
                                    <div class="col-md-4">
                                        <div class="dropdown">
                                            <div data-toggle="dropdown">
                                                <label style="padding-top: 15px;">Adesivo: <i id="meutag" style="padding-left: 60px; font-size: 30px; cursor: pointer;" title="Mudar adesivo" :class="myclass" ></i></label>
                                            </div>   
                                            <div style="width: 100%;" class="dropdown-menu dropdown-list1">
                                                <a v-for="(icone, index) in icons" :key="index"  class="dropdown-item" href="#" @click.prevent="iconeselecionado=icone.class"> (<i style="font-size: 20px; text-align: left;" :class="icone.class"></i>)  {{ icone.nickname }}</a>
                                            </div>
                                        </div> 
                                    </div>
                                    <div class="col-md-4">
                                        <label for="edditcor">Cor do adesivo:</label>
                                            <select id="edditcor" v-model="cordoicone" class="form-control form-control-sm" >
                                                <option value="">Padrão</option>
                                                <option style="background-color: #4250f2; color: aliceblue;" value="Azul">Azul</option>
                                                <option style="background-color: #ffbc00; color: #666;" value="Amarelo">Amarelo</option>
                                                <option style="background-color: #0acf97; color: aliceblue;" value="Verde">Verde</option>
                                                <option style="background-color: #f82b54; color: aliceblue;" value="Vermelho">Vermelho</option>
                                            </select>
                                    </div>
                                    <div class="col-md-12" >
                                        <label for="txtdescritivotarefa">Corpo:</label>
                                        <!-- <textarea ref="editor" class="ckeditor" v-model="conteudonotif" style="font-size: 14px;" ></textarea> -->
                                        <ckeditor type="classic" v-model="conteudonotif" :config="editorConfig" ></ckeditor>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-3 border-left">
                                <div class="row">
                                    <div class="col-md-12">
                                        <h6 style="color: #666;font-weight: 700; font-size: 14px;">
                                            Destinatário 
                                        </h6>
                                    </div>
                                    <div class="col-md-12">
                                        <span class="lblselect2">Grupo:</span>
                                        <select id="cbgrupouser" v-model="vgrupo" 
                                                data-placeholder="Selecione uma opção" data-allow-clear="true" style="width:100%;">
                                        </select>
                                    </div>
                                    <div class="col-md-12" style="margin-bottom: 10px;">
                                        <ul class="list-group">
                                            <li v-for="(usuario, index) in lstusuarios" :key="index" @click.prevent="mtdmarcarusuario(index)" class="optask-list list-group-item d-flex justify-content-between align-items-center list-group-item-action">
                                                <span><img class="img-usutarefa" v-bind:src="pathfotos+usuario.foto"><span class="nomeusulist">{{ usuario.nomeusu }}</span></span>
                                                <span v-if="parseInt(usuario.marcado) === 1"><i class="fa fa-check-circle" style="color: #57AEF1;"></i></span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button v-if="parseInt(opnotif) === 0" type="button" class="btn btn-primary btn-sm cor2" @click.prevent="mtdveranteriores(1)"><i class="fa fa-eye"></i> Anteriores</button>
                        <button v-if="parseInt(opnotif) === 0 && parseInt(opcrud) < 2" type="button" class="btn btn-primary btn-sm" style="width: 100px; border-radius: 15px;" @click.prevent="mtdincluirnotific()"><i class="fa fa-check"></i> Confirmar</button>
                        <button v-if="parseInt(opcrud)  === 2" type="button" class="btn btn-primary btn-sm" style="width: 100px; border-radius: 15px;" @click.prevent="gravaralt(opcrud)"><i class="fa fa-check"></i> Confirmar</button>
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 100px; border-radius: 15px;"><i class="fa fa-close"></i> Cancelar</button>
                    </div>
                </div>
                <div id="anterior" class="modal-content">
                    <div class="modal-header" style="padding-right: 0px;">
                        <div class="col-8 col-sm-8 col-md-8 col-lg-8 col-xl-8" style="min-height: 36px;">
                                <h4 class="modal-title">Central de notificação</h4>
                               
                        </div>
                        <button type="button" class="close" data-dismiss="modal" style="margin-right: 5px;">&times;</button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-sm-4 col-md-2 col-lg-2">
                                <label for="cbopfiltro">Filtrar:</label>
                                <select name="cbopfiltro" class="form-control form-control-sm" id="cbopfiltro" v-model="pfiltro" @change="mtdlimpar_listagem()">
                                    <option value="0">Código</option>
                                    <option value="1">Descrição</option>
                                </select>
                            </div>
                            <div class="col-sm-6 col-md-6 col-lg-6">
                                <label for="edconteudopesq">Conteúdo da pesquisa:</label>
                                <input id="edconteudopesq" type="text" class="form-control form-control-sm" v-model="pconteudo" @keyup="mtdlimpar_listagem()">
                            </div>                      
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <label for="cbqtdreg">Registros:</label>
                                <select name="cbqtdreg" class="form-control form-control-sm" id="cbqtdreg" v-model="pqtdregistros" @change="mtdlimpar_listagem()">
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="30">30</option>
                                    <option value="40">40</option>
                                    <option value="50">50</option>
                                    <option value="99999999999">Todos</option>
                                </select>
                            </div>
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <button type="button" id="btlistar" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdexecutapesquisa()"><i class="fa fa-search"></i> Listar</button>
                            </div>
                            <div class="col-md-12" style="margin-top: 10px;">
                                <vue-bootstrap4-table
                                        :rows="lstnotif"
                                        :columns="columns"
                                        :config="config"
                                        :classes="classes">
                                    <template slot="empty-results">
                                        <div class="col-md-12 text-center">Sem dados para visualização</div>
                                    </template>
                                    <!-- ícones de ordenação da table -->
                                    <template slot="sort-asc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                    </template>
                                    <template slot="sort-desc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                    </template>
                                    <template slot="no-sort-icon">
                                        <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                    </template>                                    
                                    <!--  -->                                    
                                    <template slot="codusu_f" slot-scope="item">
                                        {{ item.row.codusu }}
                                    </template>
                                    <template slot="slot_situacao" slot-scope="item">
                                        <span v-if="parseInt(item.row.ativo) === 1" class="badge badge-pill badge-success">Ativo</span>
                                        <span v-else class="badge badge-pill badge-danger">Inativo</span>
                                    </template>                                    
                                    <template slot="opcoes" slot-scope="item">
                                        <button type="button" class="btn btn-info btn-sm btn-opcrud ajt-btn" @click.prevent="mtdalterarnotif(item.row)"><i class="fa fa-edit"></i></button>
                                        <button type="button" class="btn btn-danger btn-sm btn-opcrud ajt-btn" @click.prevent="mtdexcluirnotif(item.row)"><i class="fa fa-trash"></i></button>
                                    </template>
                                </vue-bootstrap4-table>
                            </div>
                            <div class="col-md-12">
                                <ul class="list-group">
                                    <li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
                                        Registros
                                        <span class="badge badge-info badge-pill text-right bdg-qtd-reg-info">{{lstnotif.length}}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <div class="col-8 col-sm-8 col-md-10 col-lg-10" id="dvpaginacao">
                                <v-pagination
                                        v-model="pagina_atual"
                                        :page-count="pqtd_paginas"
                                        :classes="bootstrapPaginationClasses">
                                </v-pagination>
                            </div>
                        <button v-if="parseInt(opnotif) === 0" type="button" class="btn btn-primary btn-sm cor2" @click.prevent="mtdveranteriores(2)"><i class="fa fa-reply"></i> Voltar</button>
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 100px; border-radius: 15px;"><i class="fa fa-close"></i> Cancelar</button>
                    </div>
                </div>
            </div>
        </div>        
    </div>
</template>
<script>
import util from '../utilitarios/util.js';
import VueBootstrap4Table from 'vue-bootstrap4-table'
import vPagination from 'vue-plain-pagination'

export default {
    name : "cmprotinastarefa",
    components: {
        VueBootstrap4Table,
        vPagination,
       
    },
    props:[		
        'optarefacmp',
        'idtarefacmp'
    ],
    data () {
        return {
            qtdgrupo     : 0,
            pfiltro      : 1,
            pconteudo    : '',
            pativo       : 2,
            pqtdregistros: 10,
            pqtd_paginas : 1,
            pagina_atual : 1,
            pqtd_total_registros: 0,
            pathfotos           : this.$store.state.configpaths.pathimagens,

            //configurações do editor

            editorConfig: {
                toolbar: {
                    items: [
                        'undo', 'redo',
                        '|', 'heading',
                        '|', 'fontfamily', 'fontsize', 'fontColor', 'fontBackgroundColor',
                        '|', 'bold', 'italic', 'strikethrough', 'subscript', 'superscript', 'code',
                        '|', 'bulletedList', 'numberedList', 'todoList', 'outdent', 'indent'
                    ],
                    shouldNotGroupWhenFull: false,

                    language: 'pt-br'
                },
                
            },

            opnotif             : 0,
            opcrud              : 0,
            
            titulonotif         : '',
            dtnotif             : util.DataAtual(true),
            descritivotarefa    : '',
            comentario          : '',
            oplstusuario        : 0,//0 - Somente os usuários das tarefas, 1 - Todos os usuários
            lstusuarios         : [],
            vgrupo              : null,
            //variáveis para envio dos arquivos
            diretoriotarefa     : '',
            arqselecionado      : null,

            edicaoitemchecklist : false,
            descolditemchecklist: '',
            conteudonotif       : '',
            editor              : null,

            indited             : 0,
            tarefaold           : [],
            dtnotifold         : '',            
            options: {
                format           : 'DD/MM/YYYY',
                useCurrent       : false,
                locale           : 'pt-BR'
            },
            iconeselecionado     : 'fa fa-book',
            cordoicone           : '',

            myclass              : 'fa fa-book',
            usuariosmarcados     : [],
            lstnotif             : [],
            destinatarios        : [],

            icons : [
            { class: 'fa fa-cogs', nickname: 'engrenagem' },
            { class: 'fa fa-book', nickname: 'livro' },
            { class: 'fa fa-bolt', nickname: 'raio' },
            { class: 'fa fa-exclamation-triangle', nickname: 'atenção' },
            { class: 'fa fa-coffee', nickname: 'cafe' },
            { class: 'fa fa-briefcase', nickname: 'maleta' },
            { class: 'fa fa-camera', nickname: 'camera' },
            { class: 'fa fa-car', nickname: 'carro' },
            { class: 'fa fa-cloud', nickname: 'nuvem' },
            { class: 'fa fa-desktop', nickname: 'computador' },
            { class: 'fa fa-address-book', nickname: 'agenda' },
            { class: 'fa fa-user-circle', nickname: 'usuario' },
            { class: 'fa fa-camera-retro', nickname: 'camera' },
            { class: 'fa fa-envelope-open', nickname: 'email-aberto' },
            { class: 'fa fa-heart', nickname: 'coracao' },
            { class: 'fa fa-music', nickname: 'musica' },
            { class: 'fa fa-paw', nickname: 'patinha' },
            { class: 'fa fa-plane', nickname: 'aviao' },
            { class: 'fa fa-shopping-cart', nickname: 'carrinho-de-compras' },
            { class: 'fa fa-star', nickname: 'estrela' },    
            { class: 'fa fa-address-book', nickname: 'agenda' },
            { class: 'fa fa-address-card', nickname: 'cartao-de-visita' },
            { class: 'fa fa-adjust', nickname: 'ajuste' },
            { class: 'fa fa-align-center', nickname: 'alinhamento-centro' },
            { class: 'fa fa-align-justify', nickname: 'alinhamento-justificado' },
            { class: 'fa fa-align-left', nickname: 'alinhamento-esquerda' },
            { class: 'fa fa-align-right', nickname: 'alinhamento-direita' },
            { class: 'fa fa-ambulance', nickname: 'ambulancia' },
            { class: 'fa fa-american-sign-language-interpreting', nickname: 'interpretacao-de-lingua-de-sinais-americana' },
            { class: 'fa fa-anchor', nickname: 'ancora' },
            { class: 'fa fa-android', nickname: 'android' },
            { class: 'fa fa-angle-double-down', nickname: 'angulo-duplo-para-baixo' },
            { class: 'fa fa-angle-double-left', nickname: 'angulo-duplo-para-esquerda' },
            { class: 'fa fa-angle-double-right', nickname: 'angulo-duplo-para-direita' },
            { class: 'fa fa-angle-double-up', nickname: 'angulo-duplo-para-cima' },
            { class: 'fa fa-angle-down', nickname: 'angulo-para-baixo' },
            { class: 'fa fa-angle-left', nickname: 'angulo-para-esquerda' },
            { class: 'fa fa-angle-right', nickname: 'angulo-para-direita' },
            { class: 'fa fa-angle-up', nickname: 'angulo-para-cima' },
            { class: 'fa fa-apple', nickname: 'apple' },
            { class: 'fa fa-archive', nickname: 'arquivo' },
            { class: 'fa fa-area-chart', nickname: 'grafico-de-area' },
            { class: 'fa fa-arrow-circle-down', nickname: 'seta-circulo-para-baixo' },
            { class: 'fa fa-arrow-circle-left', nickname: 'seta-circulo-para-esquerda' },
            { class: 'fa fa-arrow-circle-o-down', nickname: 'seta-circulo-vazio-para-baixo' },
            { class: 'fa fa-arrow-circle-o-left', nickname: 'seta-circulo-vazio-para-esquerda' },
            { class: 'fa fa-arrow-circle-o-right', nickname: 'seta-circulo-vazio-para-direita' },
            { class: 'fa fa-arrow-circle-o-up', nickname: 'seta-circulo-vazio-para-cima' },
            { class: 'fa fa-arrow-circle-right', nickname: 'seta-circulo-para-direita' },
            { class: 'fa fa-arrow-circle-up', nickname: 'seta-circulo-para-cima' },
            { class: 'fa fa-arrow-down', nickname: 'seta-para-baixo' },
            { class: 'fa fa-arrow-left', nickname: 'seta-para-esquerda' },
   
                ],

                columns: [
                    {
                        label: 'Opções',
                        name : 'opcoes',
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        row_classes: "def-col-opcoes",
                        sort: false
                    },
                    {
                        label: 'Codigo',
                        name : 'id',
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        row_classes: "def-col-opcoes",
                        sort: false
                    },
                    {
                        label: "Descrição",
                        name:  "descnotificacao",
                        initial_sort : true,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
    
        
                ],
                config: {
                    pagination: false,
                    pagination_info: false,
                    card_mode: false,
                    global_search: {
                        visibility: false,
                    },
                    show_refresh_button : false,
                    show_reset_button : false
                },
                classes: {
                    table: "table-bordered table-striped table-sm"
                },    
                bootstrapPaginationClasses: {
                    ul: 'pagination pagination-sm',
                    li: 'page-item',
                    liActive: 'active',
                    liDisable: 'disabled',
                    button: 'page-link'
                },
                editorglobal: null,
        }
    },
    methods:{ 
        mtdfiltropesquisa(){
        let rfiltro = '';
        if (parseInt(this.pfiltro) === 0){
            rfiltro = this.pconteudo === '' ? '' : ' and n.id='+this.pconteudo;
        }else{
            rfiltro = this.pconteudo === '' ? '' : ' and upper(n.descnotificacao) like upper("'+this.pconteudo+'%")';
        }
            return rfiltro;
        },
        mtdexecutapesquisa(){
        var vself           = this;
        let filtro          = vself.mtdfiltropesquisa();
        this.pagina_atual   = 1;
        let parametros      = [
            {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
            {parametro: 'op',           valor  : 'qtdregistros'},
            {parametro: 'idusuario',    valor  : vself.$store.state.usuario.id},
            {parametro: 'filtro',       valor  : filtro}
        ];
        let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadnotificacao.php');
            retorno.then(function (response) {
            vself.pqtd_total_registros = parseInt(response.data.qtdregistros);
            let qtdpg                  = Math.ceil(vself.pqtd_total_registros / vself.pqtdregistros);
            vself.pqtd_paginas         = qtdpg > 0 ? qtdpg : 1;
            vself.mtdcarregarnotif(1);
        }).catch(function (response) {
            alert('Erro ao consultar registros');
        });
        },
        mtdcarregarnotif(ipagina){
            var vself       = this;
            let loader      = this.$loading.show();
            let filtro      = vself.mtdfiltropesquisa();
            let parametros  = [
                {parametro: 'idclientesac', valor : vself.$store.state.filialpadrao.idcliente},
                {parametro: 'op',           valor : 'listagem'},
                {parametro: 'filtro',       valor : filtro},
                {parametro: 'idusuario',    valor  : vself.$store.state.usuario.id},
                {parametro: 'limit',        valor : vself.pqtdregistros},
                {parametro: 'offset',       valor : (parseInt(ipagina) -1) * parseInt(vself.pqtdregistros)},
            ];
            let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadnotificacao.php');
            retorno.then(function (response) {
                vself.lstnotif = response.data;
            loader.hide();
            }).catch(function (response) {
                vself.lstnotif = [];
                loader.hide();
            });
        },

        async mtdigualarcampos(registro) {
        let vself = this;

        await vself.listausers(0);

        console.log(vself.lstusuarios);

        vself.vid = registro.id;                      
        vself.titulonotif = registro.descnotificacao;
        vself.conteudonotif = registro.conteudonotificacao;
        vself.dtnotif = registro.dtemissao;
        vself.iconeselecionado = registro.adesivo;
        vself.cordoicone = registro.cor;
        vself.destinatarios = registro.destinatarios;

        let usuariosMarcados = [];

            vself.lstusuarios.forEach(function(usuario) {
                usuario.marcado = 0;
                for (let i = 0; i < registro.destinatarios.length; i++) {
                    if (registro.destinatarios[i].codusu == usuario.codusu) {
                        usuario.marcado = 1;
                        usuariosMarcados.push(usuario);
                        break;
                    }
             
                }
            });

        vself.usuariosmarcados = usuariosMarcados;
        vself.myclass = `${vself.iconeselecionado} ${vself.cordoicone}`;

        //console.log(registro.destinatarios);
        },
        
        mtdmarcarusuario(index) {
            if (this.lstusuarios[index].marcado == 0) {
                this.lstusuarios[index].marcado = 1;
                this.usuariosmarcados.push(this.lstusuarios[index]);
            } else {
                this.lstusuarios[index].marcado = 0;
                let indexMarcado = this.usuariosmarcados.findIndex((u) => u.codusu == this.lstusuarios[index].codusu);
                if (indexMarcado !== -1) {
                    this.usuariosmarcados.splice(indexMarcado, 1);
                }
            }
        },

       mtdigualarcamposold(registro){
           console.log(registro)
            let vself = this
            this.vid              = registro.id;                      
            this.titulonotif      = registro.descnotificacao
            this.conteudonotif    = registro.conteudonotificacao
            this.dtnotif          = registro.dtemissao
            this.iconeselecionado = registro.adesivo
            this.cordoicone       = registro.cor
            this.destinatarios    = registro.destinatarios;
            let indexuser = 0
            this.myclass          = ''+this.iconeselecionado + " " + this.cordoicone
            
            this.lstusuarios.forEach(function(usuario) {
                usuario.marcado = 0;
            });

            // for (let index = 0; index <  this.destinatarios.length; index++) {
            //     indexuser = util.getArrayIndexForKey(this.lstusuarios, 'codusu',  this.destinatarios[index].codusu)
            //     this.mtdmarcarusuario(indexuser)
            // }
            // var usuarios          = vself.lstusuarios;    
            // this.usuariosmarcados = usuarios
            // .filter(function(usuario) {
            //     return usuario.marcado === 1;
            // })
            // .map(function(usuario) {
            //     usuario.marcado = 1;
            //     return usuario;
            // });
       
              // Marca os usuários correspondentes
            for (let index = 0; index < this.destinatarios.length; index++) {
                let codusu = this.destinatarios[index].codusu;
                let indexuser = util.getArrayIndexForKey(this.lstusuarios, 'codusu', codusu);

                if (indexuser !== undefined && indexuser >= 0 && indexuser < this.lstusuarios.length) {
                    let usuario = this.lstusuarios[indexuser];
                    usuario.marcado = 1;
                }
            }

            // Atualiza a lista de usuários marcados
            this.usuariosmarcados = this.lstusuarios.filter(function(usuario) {
                return usuario.marcado === 1;
            });

            console.log(this.usuariosmarcados);
                 
        },
        resetadados(){
            this.opcrud           = 0
            this.vid              = 0                       
            this.titulonotif      = ''
            this.conteudonotif    = ''
            this.dtnotif          = util.DataAtual(true)
            this.myclass          = ''
            this.iconeselecionado = 'fa fa-book'
            this.cordoicone       = ''
            this.usuariosmarcados = []
            this.lstusuarios = []
        },
        mtdlimpar_listagem() {
            this.lstnotif = [];
            this.pagina_atual = 1;
            this.filtro = '';
            this.pqtd_total_registros = 0;
            this.pqtd_paginas = 0;
        },
        mtdregistro(op){
            let vself  = this;
                let loader = vself.$loading.show();
                let registrocrud = {
                    'id'                 : this.vid,
                    'idususario'         : this.$store.state.usuario.id,
                    'descricao'          : this.titulonotif,
                    'conteudonotificacao': this.conteudonotif,
                    'idtarefa'           : 0,
                    'tipo'               : 3,
                    'idfilial'           : this.$store.state.filialpadrao.codfil,
                    'dtvalidade'         : this.dtnotif,
                    'adesivo'            : this.iconeselecionado,
                    'cor'                : this.cordoicone,
                    'usuariosnotificar'  : this.usuariosmarcados
                };
                let parametros      = [
                    {parametro: 'idclientesac',       valor : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',                 valor : 'rotinacrud'},
                    {parametro: 'opcrud',             valor : op},
                    {parametro: 'registro',           valor : JSON.stringify(registrocrud)},
                    {parametro: 'idfilial',           valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idusuario',          valor : vself.$store.state.usuario.id},
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadnotificacao.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data)){
                        vself.$toastr.s('Registro processado com sucesso!', 'Informação!');   
                        if(parseInt(vself.opcrud)=== 2){
                            vself.preparalista(response.data)
                        }  
                        if(parseInt(vself.opcrud)=== 3){
                            vself.preparalista(response.data)
                        }  
                        vself.resetadados();
                    }else{
                        let tpret = response.data.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                break;
                        }
                    }
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });
        },
        gravar(op){
            let vself = this;
            let oprecao = ''
            switch(op){
                case 1:
                  oprecao = 'INCLUSÃO';
                break;

                case 2:
                  oprecao = 'ALTERAÇÃO';  
                break;
                   
                case 3:
                  oprecao = 'EXCLUSÃO';
                break;
            } 

            $.confirm({
                    title: 'Confirmação!',
                    content: 'Confirma ' + oprecao + '?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                $('.btn-blue').prop('disabled', true);
                                vself.mtdregistro(op);
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                                $('#btgravar').focus();
                            }
                        }
                    }
                });
        }, 
        mtdincluirnotific(){
            var op = 1
            var usuarios          = this.lstusuarios;
            this.usuariosmarcados = [];
     
            let marcados = usuarios
                .filter(function(usuario) {
                    return usuario.marcado === 1;
                })
                .map(function(usuario) {
                    usuario.marcado = 1;
                    return usuario;
                });


            if (this.titulonotif === '') {
                this.$toastr.w('O titulo da notificação deve ser informado!', 'Atenção!');
                $('#eddtventit').focus();
                return;
            }
            if (this.conteudonotif==='') {
                this.$toastr.w('O conteudo da notificação deve ser informado!', 'Atenção!');
                $('#edvltit').focus();
                return;
            }
            if(marcados.length == 0){
                this.$toastr.w('Informe os destinatários da notificação!', 'Atenção!');
                return;
            }
            this.usuariosmarcados = marcados
            this.gravar(op);
        },
        gravaralt(op){
            var usuarios          = this.lstusuarios;
            this.usuariosmarcados = [];
     
            let marcados = usuarios
                .filter(function(usuario) {
                    return usuario.marcado === 1;
                })
                .map(function(usuario) {
                    usuario.marcado = 1;
                    return usuario;
                });

            if (this.titulonotif === '') {
                this.$toastr.w('O titulo da notificação deve ser informado!', 'Atenção!');
                $('#eddtventit').focus();
                return;
            }
            if (this.conteudonotif==='') {
                this.$toastr.w('O conteudo da notificação deve ser informado!', 'Atenção!');
                $('#edvltit').focus();
                return;
            }
            if(marcados.length == 0){
                this.$toastr.w('Informe os destinatáarios da notificação!', 'Atenção!');
                return;
            }
            this.usuariosmarcados = marcados
            this.gravar(op);
        },
        mtdlocalizaregistro(id){
            var vself       = this;
            let loader      = vself.$loading.show();
            let filtro      = ' and n.id='+id;
            let parametros  = [
                {parametro: 'op',           valor : 'listagem'},
                {parametro: 'idclientesac', valor : vself.$store.state.filialpadrao.idcliente},
                {parametro: 'filtro',       valor : filtro},
                {parametro: 'limit',        valor : 1},
                {parametro: 'offset',       valor : 0},
                {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
            ];
            let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadnotificacao.php');
            retorno.then(function  (response) {
                loader.hide();
                vself.mtdigualarcampos(response.data[0]);
              
            }).catch(function (response) {
                loader.hide();
            });
        }, 
        mtdalterarnotif(item){ 
            this.mtdveranteriores(0)
            this.opcrud = 2
            this.mtdlocalizaregistro(item.id)       
        },
        mtdexcluirnotif(item){
            this.resetadados();
            this.listausers(0)
            this.opcrud = 3;
            this.mtdlocalizaregistro(item.id)
            this.gravar(3)
        },
        mtdmarcarusuarioold(index) {      
            if (parseInt(this.lstusuarios[index].marcado) === 0) {
                this.lstusuarios[index].marcado = 1;
            }else{
                this.lstusuarios[index].marcado = 0;
            }  
        },
        preparalista(){
            this.opcrud = 0;
            this.resetadados();
            this.listausers(0);
            this.mtdveranteriores(1);
        },
        mtdveranteriores(op){
            if(op===1){
                $("#incluir").hide()
                $("#anterior").show()
                this.opcrud = 0;
                this.resetadados();
                this.mtdexecutapesquisa();
            }else{
                this.resetadados();
                this.listausers(0);
                $("#anterior").hide()
                $("#incluir").show()
            }
        },     
        mtdformadardataextenso(data, mostrahr) {
            if (!mostrahr) {
                return util.dataextenso(util.InverterData(data) + 'T00:00:00');
            }else{
                let vdthr = data.split('T');
                let vhr   = vdthr[1].split(':');
                return util.dataextenso(util.InverterData(data) + 'T00:00:00')+' às '+vhr[0]+':'+vhr[1];
            }
        },       
        mtdtransformadata: function(dttrasnf){
            return util.formatadatahrdb(dttrasnf);
        },  
        mtdmarcarusuariogp(grupo){
            let usuariosMarcados = [];

            this.lstusuarios.forEach(function(usuario) {
               if(usuario.grupo == grupo){
                  usuario.marcado = 1;
               }else{
                  usuario.marcado = 0;
               }
            });

            vself.usuariosmarcados = usuariosMarcados;

        },
        async listausers(grupo){
            let vself           = this;
            let parametros      = [
                {parametro: 'idclientesac', valor : vself.$store.state.filialpadrao.idcliente},
                {parametro: 'op',           valor : 'listaruser'},
                {parametro: 'grupouser',    valor : grupo},
            ];
            try {
                const response = await util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadnotificacao.php');
                vself.lstusuarios = response.data;
                return response.data;
            } catch (error) {
                console.error(error);
                return [];
        }
        },
        mtdefuniciais(){
            let vself =  this;
            vself.listausers(0)
            $("#cbgrupouser").select2({
                id: function(e) {
                    return e.id
                },
                ajax: {
                    url: vself.$store.state.configpaths.pathselect2,
                    dataType: 'json',
                    delay: 250,
                    data: function(params) {
                        return {
                            q: params.term,
                            idclientesac: vself.$store.state.filialpadrao.idcliente,
                            tb: 'tbgruposusuarios',
                            c1: 'id',
                            c2: 'descricao'
                        };
                    },
                    processResults: function(data) {
                        return {
                            results: data
                        };
                    },
                    cache: true
                },
                minimumInputLength: 0,
                theme: 'bootstrap',
                language: "pt-BR",
                templateResult: util.formatResult,
                templateSelection: util.formatSelection
            }).change(function() {
                if(vself.opcrud === 0 || vself.opcrud === 1){
                    vself.vgrupo = $("#cbgrupouser").val();
                    vself.listausers(vself.vgrupo);
                }else{
                    vself.mtdmarcarusuariogp(vself.vgrupo)
                }
            });
        },
    
    },
    mounted: function () {    
        let vself = this;

       $('#mdcentralntificacao').on('shown.bs.modal', function () {
          vself.pathfotos = vself.$store.state.configpaths.pathimagens
       //   vself.listausers(0);
          vself.mtdefuniciais();  
        });

        $('#mdcentralntificacao').on('hide.bs.modal', function () {
            vself.resetadados();
        });
        $("#anterior").hide();
    },    
    computed:{
        abrirtela(){
            return this.$store.state.rotinatarefas.abrirtela;                
        }        
    },
    watch:{
        cordoicone(){
            this.myclass = ''+this.iconeselecionado + " " + this.cordoicone
        },
        iconeselecionado(){
            this.myclass = ''+this.iconeselecionado + " " + this.cordoicone
        },
        pagina_atual(val){
            this.mtdcarregarnotif(val);
        }
    }    
}
</script>
<style>
    .Azul{
        color: #4250f2;
    }
    .Amarelo{
        color: #ffbc00;
    }
    .Verde{
        color: #0acf97;
    }
    .Vermelho{
        color: #f82b54;
    }
    .dropdown-list1 {
        max-height: 300px; /* altura máxima que o elemento dropdown pode ter */
        overflow: auto; /* adiciona a barra de rolagem quando o conteúdo excede a altura máxima */
    }
    .select-wrapper {
        position: relative;
        display: inline-block;
    }

    .option {
        display: flex;
        align-items: center;
        padding: 5px 10px;
        cursor: pointer;
    }

    .option:hover {
        background-color: #f0f0f0;
    }

    .option i {
     margin-right: 10px;
    }

    .select-wrapper::before {
        content: "";
        position: absolute;
        top: 50%;
        right: 10px;
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 5px 5px 0 5px;
        border-color: #666 transparent transparent transparent;
        transform: translateY(-50%);
        pointer-events: none;
    }

    .select-wrapper.open::before {
        border-width: 0 5px 5px 5px;
        border-color: transparent transparent #666 transparent;
    }
    .cor2{
        background-color: #0e7380 !important;
    }
    .modal-body .ck-editor__editable {
         height: 200px;
    }
    .optask-list{
        cursor: pointer;
        padding: 5px 15px 5px 15px!important;
    }
    .optask-list:hover #edchecklist{
        background: #F8F9FA;
    }
    .tit-checklist{
        padding-top: 2px;
        font-size: 12px;
        color: #666;
    }
    .link-add{
        text-decoration: none;
        cursor: pointer;
        color: #57AEF1;
    }
    .link-add:hover{
        color: #5292d0;
    }
    .bt-op-tarefa{
        position: absolute;
        color: #a6a6a6;
        font-size: 22px;
        left: 5px;
    }
    .bt-exc-tarefa {
        float: right;
        color: #a6a6a6;
        font-size: 22px;
    }
    .bt-op-tarefa:hover{
        color: #6B6B6B;
    }
    .bt-exc-tarefa:hover{
        color: #6B6B6B;
    }
    #edchecklist{
        width: 100%;
        min-height: 70px;
        border: 0px;
        font-size: 14px;
    }
    #edchecklist:focus{
        box-shadow: 0 0 0 0;
        border: 0 none;
        outline: 0;
    }
    .btn-participantes{
        font-size: 12px!important;
        width: 20px!important;
        height: 20px!important;
        padding: 0px!important;
        margin-top: -5px;
    }
    .icone-atividade{
        margin: 50%;
        font-size: 25px;
    }
    .tit-atividade{
        font-size: 12px;
        color: #a2a2a2;
        margin-bottom: 0px;
    }
    .det-dthratividade{
        font-size: 10px;
        color: #a2a2a2;
        margin-bottom: 0px;
    }
    .det-atividade{
        font-size: 12px;
        color: #a2a2a2;
        margin-bottom: 0px;
    }
    .card-comentario{
        margin-top: 2px;
        margin-right: 25px;
        flex-grow: 1;
        flex-shrink: 1;
        padding-left: 12px;
        border-radius: 5px;
        position: relative;
        background-color: rgb(247, 249, 250);
        box-shadow: rgba(0, 0, 0, 0.15) 0px 1px 1px 0px;
        margin-bottom: 2px;
    }
    .corpo-comentario{
        font-size: 14px;
        color: #a2a2a2;
    }    
    
    .custom-select select {
    display: block;
    width: 100%;
    height: calc(2.25rem + 2px);
    padding: 0.375rem 1.75rem 0.375rem 0.75rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    }

    .custom-select select:focus {
    border-color: #80bdff;
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
    }

    .custom-select i {
    margin-right: 0.5rem;
    }
</style>